<template>
  <div id="el-footer">
    <div class="footer-list">
      <div class="footer-list-inner">
        <div class="footer-list-item">
          <div class="footer-list-item-title">
            <i class="iconfont icon-all-fill"></i>
            <h2>运踪信息查询平台</h2>
          </div>
          <p>直面全球商机，让您的选择拥有更多的线路，更省的运费，更快的时效，进而开启铁路贸易新机遇。</p>
        </div>
        <div class="footer-list-item">
          <div class="footer-list-item-txt">
            <h3>联系我们</h3>
            <a>0532-68607898</a>
            <a>info@jagich.com</a>
            <a>QQ：2065145272</a>
          </div>
        </div>
        <div class="footer-list-item">
          <div class="footer-list-item-txt">
            <h3>新手上路</h3>
            <a>新手指南</a>
            <a>使用协议</a>
            <a>版权隐私</a>
          </div>
        </div>
        <div class="footer-list-item">
          <div class="footer-list-item-mtitle">
            <h3>消息订阅</h3>
          </div>
          <div class="footer-list-item-mail">
            <span>获取产品资讯</span>
            <label><input type="email" placeholder="请输入您的邮箱"></label>
            <button type="button">订阅</button>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-info">
      <div class="footer-info-txt">
        <p>运踪信息查询平台 Copyright©2014-2021</p>
        <div class="footer-info-txt-certificate">
          <p>鲁公网安备37020202000881号</p>
          <a href="https://beian.miit.gov.cn/" target="_blank">鲁ICP备11032919号-3</a>
        </div>
      </div>
    </div>
    <div class="el-upTips">
      <ul>
        <li class="r1">
          <img :src="ico4" alt="" />
          <span>0532-68607898</span>
        </li>
        <li class="r2">
          <a href="http://wpa.qq.com/msgrd?v=3&uin=2065145272&site=qq&menu=yes" target="_blank">
            <img :src="ico5" alt="" />
          </a>
        </li>
        <li class="r3" @click="backTop()">
          <img :src="ico6" alt="" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Footer",
    data() {
      return {
        imgs: "./static/images/ewm1.jpg",
        ico1: "./static/images/kf1.png",
        ico2: "./static/images/kf2.png",
        ico3: "./static/images/kf3.png",
        ico4: "./static/images/r1.png",
        ico5: "./static/images/r2.png",
        ico6: "./static/images/r3.png",
      };
    },
    methods: {
      //返回顶部
      backTop() {
        const that = this;
        let ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed;
      },
      //
    },
  };
</script>

<style scoped>
  @import "./comp/footer.css";
  @import "../../../static/font/iconfont.css";
</style>



// WEBPACK FOOTER //
// src/components/global/footer.vue